import { UserService } from '../../../services/user.service';
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { I18nService } from 'src/app/services/i18n.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { User } from '../../../models/user';
import { DialogContentLogin } from '../login-dialog/dialog-content-login';
import { MatDialog } from '@angular/material/dialog';
import * as CryptoJS from 'crypto-js';
import { getPasswordStrength, passwordPolicyValidator, PasswordStrengthLevel } from 'src/app/shared/password-strength';

export interface DialogData {
  acceptInscription: boolean;
  email: any;
}

function passwordsMatchValidator(group: FormGroup): ValidationErrors | null {
  const password = group.get('password')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;
  return password === confirmPassword ? null : { passwordsMismatch: true };
}

@Component({
    selector: 'dialog-content-inscription',
    templateUrl: 'dialog-content-inscription.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogContentInscription {

  inscriptionForm!: FormGroup;
  loading = false;
  submitted = false;
  returnUrl!: string;
  error = '';
  user!: User;
  successInscription : boolean = false;
  errorFetch: boolean = false;
  email!: string;
  dialogRef: any;
  cookiesNewsletter!: string | null;
  acceptNewsLetter: boolean = false;

  tokenFromUI: string = "0123456789123456";
  encrypted: any = "";
  decrypted: string = "test";

  request!: string;
  responce!: string;

  strengthLevel: PasswordStrengthLevel = 'faible';

  private i18n = inject(I18nService);

  constructor(
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private userService: UserService,
      public dialog: MatDialog
  ) {
      // redirect to home if already logged in
      // if (this.authenticationService.userValue) {
      //     this.router.navigate(['/']);
      // }
  }

  ngOnInit() {
      this.inscriptionForm = this.formBuilder.group({
          email: ['', [Validators.required, Validators.email]],
          password: ['', [Validators.required, passwordPolicyValidator()]],
          confirmPassword: ['', Validators.required],
          // Deux consentements distincts, décochés par défaut (RGPD) ; confirmés par la validation du compte
          newsletter: [false],
          partnerOffers: [false]
      }, { validators: passwordsMatchValidator });

      this.inscriptionForm.get('password')?.valueChanges.subscribe((value: string) => {
        this.strengthLevel = getPasswordStrength(value).level;
      });

      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { return this.inscriptionForm.controls; }

  onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.inscriptionForm.invalid) {
          return;
      }

      this.loading = true;

      const { confirmPassword, ...userToRegister } = this.inscriptionForm.value;
      this.userService.inscription({ ...userToRegister, language: this.i18n.current }).subscribe(() => {
        this.loading = false;
        this.successInscription = true;
      }, (err) => {
        this.loading = false;
        this.errorFetch = true;
        this.error = err || this.i18n.t('common.errorOccurred');
      });
  }

  encryptUsingAES256() {
    let _key = CryptoJS.enc.Utf8.parse(this.f.email.value);
    let _iv = CryptoJS.enc.Utf8.parse(this.f.password.value);

    // 🔐 Chiffrement AES
    let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(this.request),
        _key,
        {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB, // ⚠️ ECB n'utilise pas d'IV, préférer CBC
            padding: CryptoJS.pad.Pkcs7
        }
    );

    this.encrypted = encrypted.toString();
    alert("Texte chiffré: " + this.encrypted);
}

  decryptUsingAES256() {
    this.decrypted = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(this.encrypted));
    alert(this.decrypted);
  //   let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
  //  // CryptoJS.enc.Base64.stringify(words)

  //   this.decrypted = CryptoJS.AES.decrypt(
  //     this.encrypted, _key, {
  //       keySize: 16,
  //       iv: _iv,
  //       mode: CryptoJS.mode.ECB,
  //       padding: CryptoJS.pad.Pkcs7
  //     }).toString(CryptoJS.enc.Utf8);
  }

  public setConsent(value: any): void {
    localStorage.setItem('cookies_login', value);
  }

  public openDialogLogin(): void {
    this.dialogRef = this.dialog.open(DialogContentLogin, {
      width: '550px',
      data: { acceptNewsLetter: this.acceptNewsLetter, email: this.email },
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.acceptNewsLetter = result?.acceptNewsLetter;
      this.email = result?.email;
      if (result === false) {
        this.setConsent("0");
        this.cookiesNewsletter = "0";
      } else {
        this.setConsent("1");
        this.cookiesNewsletter = "1";
      }
    });

  }
}
